import {
  Button,
  Flex,
  Icon,
  Input,
  SimpleGrid,
  Spinner,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  BLUEMONEDD,
  BLUEMONEDDBUTTONS,
  GRAY_NEUTRAL,
  GREENMONEDD,
  REDMONEDD,
  VARIANT,
  WHITE,
} from "../../../../../constants/colors";

import jwt_decode from "jwt-decode";
import { FaArrowLeft, FaArrowRight, FaFileExport } from "react-icons/fa";

import fileDownload from "js-file-download";
import { toast } from "react-toastify";

import { useRecoilState } from "recoil";
import { JWTToken } from "../../../../../routes/privateRoute";
import { LoggedUser } from "../../../../../atoms/userLogged";
import { selectedClientHeader } from "../../../../../atoms/selectedClientHeader";
import {
  ExtractListCards,
  simplifiedExtract,
} from "../../../../../interfaces/defaultInterfaces";
import ExtratoApi from "../../../../../services/ExtratoAPI";
import SalesListAPI from "../../../../../services/SalesListApi";
import { dateForValueInput } from "../../../../../constants/dataFormat";
import CardExtractDetails from "../../../../financeiro/consultaTransacoes/defaultComponents/cardExtractDetails";
import TableRelease from "../../../../financeiro/consultaTransacoes/defaultComponents/tableRelease";
import TableTransfers from "../../../../financeiro/consultaTransacoes/defaultComponents/tableTransfers";
import TableTransfersWithStatus from "../../../../financeiro/consultaTransacoes/defaultComponents/tableTransfersWithStatus";
import TableSalesCredit from "../../../../financeiro/consultaTransacoes/defaultComponents/tableSalesCredit";
import TableSplitExtract from "../../../../financeiro/consultaTransacoes/defaultComponents/tableSplitExtract";

export default function ExtratoClienteSupervisor() {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const { idCliente } = useParams();
  const id = Number(idCliente);

  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  // const id = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);

  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");

  const [extractList, setExtractList] = useState(Array<simplifiedExtract>);
  // Linhas da ExtratoSplit no mesmo periodo. O extrato principal so mostra
  // quanto foi splitado de cada venda (valorExtratoSplit); o que SAI do saldo
  // splitado (repasse automatico) so existe deste lado.
  const [splitList, setSplitList] = useState(Array<simplifiedExtract>);
  // Saldo do razao split e se o cliente opera com split. Vem de /ExtratoSplit/saldo
  // porque ele nao depende do periodo: sem isso a faixa sumia no dia sem
  // lancamento, como se o cliente tivesse deixado de ter split.
  const [splitSaldo, setSplitSaldo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const [clienteTemSplit, setClienteTemSplit] = useState(false);
  const [cardExtract, setCardExtract] = useState<any>();
  const [saldoAtual, setSaldoAtual] = useState(0);
  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };
  const [saldo, setSaldo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const [filtros, setFiltros] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  async function getExtractDetails() {
    try {
      // V2: uma consulta so, ja com a ponte do split resolvida no servidor.
      // Sem paginacao de proposito — esta tela agrupa por tipo de lancamento e
      // precisa do periodo inteiro para os totais de cada bloco fecharem.
      const response = await ExtratoApi.getExtractPerClientV2(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setExtractList(response.data || []);
    } catch (error) {
      setExtractList([]);
      console.log("error", error);
    }
  }

  async function getSplitDetails() {
    try {
      const response = await ExtratoApi.getSplitPerClientV2(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setSplitList(response.data || []);
    } catch (error) {
      // Cliente sem split nao tem nada deste lado — a tela segue igual.
      setSplitList([]);
      console.log("error", error);
    }
  }

  async function getSplitSaldo() {
    try {
      const response = await ExtratoApi.getSplitSaldo(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      // A consulta agrupa o razao inteiro do cliente, sem recorte de data: linha
      // presente = ele tem (ou ja teve) movimentacao no split.
      const linha = response.data?.[0];
      setClienteTemSplit(!!linha);
      setSplitSaldo({
        saldoAnterior: linha?.saldoAnterior ?? 0,
        saldoPeriodo: linha?.saldoPeriodo ?? 0,
      });
    } catch (error) {
      setClienteTemSplit(false);
      setSplitSaldo({ saldoAnterior: 0, saldoPeriodo: 0 });
      console.log("error", error);
    }
  }

  async function getExtratcList() {
    try {
      const response = await ExtratoApi.getExtractList(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id,
        ""
      );

      // periodo sem lancamento devolve lista vazia: sem a guarda, a tela
      // quebrava ao inves de mostrar zero
      const cards = response?.[0];
      setCardExtract(cards);

      const somaSaldoPositivo =
        (cards?.vendaCartaoDebito || 0) +
        (cards?.vendaCartao || 0) +
        (cards?.sucessoDisputa || 0) +
        (cards?.vendaBoleto || 0) +
        (cards?.vendaBolepix || 0) +
        (cards?.vendaPix || 0) +
        (cards?.lancamentoManualCredito || 0);
      const somaSaldoNegativo =
        (cards?.cancelamentoVendaCartao || 0) +
        (cards?.disputaVendaCartao || 0) +
        (cards?.cancelamentoBoleto || 0) +
        (cards?.cancelamentoBolepix || 0) +
        (cards?.cancelamentoPIX || 0) +
        (cards?.pagamentoBoleto || 0) +
        (cards?.transferenciaTED || 0) +
        (cards?.lancamentoManualDebito || 0);
      setSaldoAtual(somaSaldoPositivo - somaSaldoNegativo);
    } catch (error) {
      console.log("error", error);
    }
  }

  async function getSaldo() {
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      console.log("getSaldo", response);
      setSaldo({
        ...saldo,
        saldoAnterior: response.data[0].saldoAnterior,
        saldoPeriodo: response.data[0].saldoPeriodo,
      });
    } catch (error) {
      console.log("error", error);
    }
  }

  // Um loading so para as quatro consultas: antes o spinner sumia quando o
  // extrato principal respondia, e cards, saldo e split ainda entravam depois —
  // a tela mostrava numero velho/zerado por um instante.
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        await Promise.all([
          getExtractDetails(),
          getSplitDetails(),
          getSplitSaldo(),
          getExtratcList(),
          getSaldo(),
        ]);
      } finally {
        setLoading(false);
      }
    })();
  }, [filtros.initialDateFilter, filtros.finalDateFilter, id]);

  // Totais do split no periodo, na mesma leitura dos demais cards: soma por
  // sinal do tipo de lancamento (C = entrou no saldo splitado, D = saiu).
  const splitCredito = splitList
    .filter((item: any) => item?.tipoLancamento?.sinal === "C")
    .reduce((acc: number, item: any) => acc + item.valor, 0);
  const splitDebito = splitList
    .filter((item: any) => item?.tipoLancamento?.sinal === "D")
    .reduce((acc: number, item: any) => acc + item.valor, 0);
  // Basta o cliente operar com split para a faixa aparecer — dia sem lancamento
  // mostra zerado e o saldo acumulado, em vez de esconder o bloco.
  const temSplit = clienteTemSplit || splitList.length > 0;

  const [disable, setDisable] = useState(false);

  async function Export() {
    try {
      setDisable(true);
      const response = await SalesListAPI.exportDetailedExtract(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      fileDownload(response, "extrato.xlsx");
      setDisable(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      bgColor={WHITE}
      shadow={"xl"}
      flexDirection={"column"}
      overflowY={"scroll"}
    >
      <Flex
        w={"100%"}
        minH={"fit-content"}
        flexShrink={0}
        py={7}
        px={10}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        {/* <Text fontWeight={"bold"}>
          Consulta de Transações:{" "}
          {cardExtract
            ? cardExtract.isCnpj === true
              ? cardExtract.razaoSocial
              : `${cardExtract.nome} ${cardExtract.sobrenome}`
            : ""}
        </Text> */}
        <Flex
          // mx={4}
          // mt={4}
          color={BLUEMONEDDBUTTONS}
          fontWeight={"bold"}
          alignItems={"center"}
        >
          <Text h={"100%"} fontSize={35} mx={4}>
            Consulta de Transações:
          </Text>
          <Text pt={2} h={"100%"} fontSize={20}>
            {loading ? (
              <Spinner />
            ) : cardExtract ? (
              cardExtract.isCnpj ? (
                cardExtract.razaoSocial
              ) : (
                `${cardExtract.nome} ${cardExtract?.sobrenome}`
              )
            ) : (
              ""
            )}
          </Text>
        </Flex>
        <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          isDisabled={disable}
          onClick={() => {
            Export();
          }}
        >
          {disable === true ? (
            <Spinner />
          ) : (
            <>
              <Icon mr={2} as={FaFileExport} />
              Exportar
            </>
          )}
        </Button>
      </Flex>
      <Flex
        w={"97%"}
        minH={"fit-content"}
        flexShrink={0}
        py={4}
        px={10}
        marginX={"auto"}
        mb={4}
        border={"2px solid #e3e3e3"}
        shadow={"md"}
        borderRadius={"8px"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
      >
        <Button
          bgColor={BLUEMONEDD}
          color={WHITE}
          isDisabled={loading}
          onClick={() => {
            setFiltros({
              ...filtros,
              initialDateFilter: moment(filtros.initialDateFilter)
                .add(-1, "day")
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              finalDateFilter: moment(filtros.finalDateFilter)
                .add(-1, "day")
                .endOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
            });
          }}
        >
          {loading ? (
            <Spinner />
          ) : (
            <>
              <Icon mr={2} as={FaArrowLeft} />
              Anterior
            </>
          )}
        </Button>
        <Input
          value={moment(filtros.initialDateFilter).format(dateForValueInput)}
          type={"date"}
          w={"22%"}
          isDisabled={loading}
          onChange={(e: any) => {
            setFiltros({
              ...filtros,
              initialDateFilter: moment(e.target.value)
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              finalDateFilter: moment(e.target.value)
                .endOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
            });
          }}
        ></Input>
        {/* <DateDropdown filtros={filtros} setFiltros={setFiltros} /> */}
        <Button
          bgColor={BLUEMONEDD}
          color={WHITE}
          isDisabled={loading}
          onClick={() => {
            setFiltros({
              ...filtros,
              initialDateFilter: moment(filtros.initialDateFilter)
                .add(1, "day")
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              finalDateFilter: moment(filtros.finalDateFilter)
                .add(1, "day")
                .endOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
            });
          }}
        >
          {loading ? (
            <Spinner />
          ) : (
            <>
              Posterior
              <Icon ml={2} as={FaArrowRight} />
            </>
          )}
        </Button>
      </Flex>
      <Flex
        w={"97%"}
        h={"fit-content"}
        flexShrink={0}
        border={"2px solid #e3e3e3"}
        shadow={"md"}
        marginX={"auto"}
        alignItems={"center"}
        mb={1}
        py={3}
        borderRadius={"8px"}
        minH={"90px"}
      >
        {loading ? (
          <Flex w={"100%"} justifyContent={"center"} alignItems={"center"}>
            <Spinner color={VARIANT} size="lg" />
          </Flex>
        ) : (
        <SimpleGrid columns={6} spacingX={4} spacingY={2} w={"100%"} px={5}>
          <CardExtractDetails
            valor={saldo.saldoAnterior}
            description={`Saldo em ${moment(filtros.initialDateFilter)
              .add(-1, "day")
              .format("DD/MM/YYYY")}`}
            color={BLUEMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaCartao : 0}
            description={"Vendas Crédito"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract?.vendaCartaoDebito : 0}
            description={"Vendas Débito"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaBoleto : 0}
            description={"Vendas Boletos"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaPix : 0}
            description={"Vendas PIX"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.lancamentoManualCredito : 0}
            description={"Lançamentos de Crédito"}
            color={GREENMONEDD}
          />

          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoBoleto : 0}
            description={`Cancelamento Boleto`}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoPIX : 0}
            description={`Cancelamento Pix`}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaBolepix : 0}
            description={"Vendas BolePix"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoRemessaBoleto : 0}
            description={`Cancelamento Remessa Boleto`}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={
              cardExtract ? cardExtract.cancelamentoRemessaTransferencia : 0
            }
            description={`Cancelamento Remessa Transferencia`}
            color={REDMONEDD}
          />

          <CardExtractDetails
            valor={cardExtract ? cardExtract.lancamentoManualDebito : 0}
            description={"Lançamentos de Débito"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.pagamentoBoleto : 0}
            description={"Pagamentos de Boleto"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoBolepix : 0}
            description={"Cancelamento BolePix"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.transferenciaTED : 0}
            description={"Transferências"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoVendaCartao : 0}
            description={"Vendas Canceladas"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.disputaVendaCartao : 0}
            description={"Venda Disputada"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={saldo.saldoAnterior + saldo.saldoPeriodo}
            description={`Saldo em ${moment(filtros.finalDateFilter).format(
              "DD/MM/YYYY"
            )}`}
            color={BLUEMONEDD}
          />

          {/* <CardExtractDetails
            valor={cardExtract?.sucessoDisputa}
            description={`Sucesso Disputa`}
            color={BLUEMONEDD}
          /> */}
        </SimpleGrid>
        )}
      </Flex>

      {/* Extrato split em faixa propria: e outro razao (tabela ExtratoSplit),
          e misturar no grid acima deixava a ultima linha de cards quebrada. */}
      {loading === false && temSplit ? (
        <Flex
          w={"97%"}
          h={"fit-content"}
          flexShrink={0}
          border={"2px solid #e3e3e3"}
          shadow={"md"}
          marginX={"auto"}
          flexDirection={"column"}
          mb={1}
          mt={2}
          borderRadius={"8px"}
          py={2}
        >
          <Text
            fontSize={"12px"}
            fontWeight={"bold"}
            color={"gray.500"}
            textTransform={"uppercase"}
            letterSpacing={"wider"}
            px={5}
            pb={1}
          >
            Extrato Split
          </Text>
          <SimpleGrid columns={3} spacingX={4} spacingY={2} w={"100%"} px={5}>
            <CardExtractDetails
              valor={splitCredito}
              description={"Entradas do Split"}
              color={GREENMONEDD}
            />
            <CardExtractDetails
              valor={splitDebito}
              description={"Saídas do Split"}
              color={REDMONEDD}
            />
            {/* saldoAnterior + saldoPeriodo, e nao entradas - saidas: aquele e o
                liquido do dia, este e o saldo que o cliente realmente tem no
                razao split — mesma leitura do "Saldo em" da faixa principal. */}
            <CardExtractDetails
              valor={splitSaldo.saldoAnterior + splitSaldo.saldoPeriodo}
              description={`Saldo do Split em ${moment(
                filtros.finalDateFilter
              ).format("DD/MM/YYYY")}`}
              color={BLUEMONEDD}
            />
          </SimpleGrid>
        </Flex>
      ) : (
        <></>
      )}

      {loading === false ? (
        <Flex
          w={"100%"}
          minH={"60vh"}
          flexShrink={0}
          alignItems={"flex-start"}
          px={5}
          flexDirection={"column"}
        >
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Crédito"
              item.tipoLancamento.id == 23
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento ==
                    // "Lançamento Manual Crédito"
                    item.tipoLancamento.id == 23
                )
              }
              title={"Transferência Via Rede Crédito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Crédito"
              item.tipoLancamento.id == 24
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento ==
                    // "Lançamento Manual Crédito"
                    item.tipoLancamento.id == 24
                )
              }
              title={"Transferência Via Rede Débito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Crédito"
              item.tipoLancamento.id == 16
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento ==
                    // "Lançamento Manual Crédito"
                    item.tipoLancamento.id == 16
                )
              }
              title={"Lançamento Manual Crédito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Débito"
              item.tipoLancamento.id == 17
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Lançamento Manual Débito"
                    item.tipoLancamento.id == 17
                )
              }
              title={"Lançamento Manual Débito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Transferencia TED"
              item.tipoLancamento.id == 15
          ).length ? (
            <TableTransfers
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Transferencia TED"
                    item.tipoLancamento.id == 15
                )
              }
              title={"Transferencia TED"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Transferencia TED"
              item.tipoLancamento.id == 20
          ).length ? (
            <TableTransfersWithStatus
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Transferencia TED"
                    item.tipoLancamento.id == 20
                )
              }
              title={"Cancelamento/Falha de Remessa Transferencia"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Pagamento Boleto"
              item.tipoLancamento.id == 14
          ).length ? (
            <TableTransfers
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Pagamento Boleto"
                    item.tipoLancamento.id == 14
                )
              }
              title={"Pagamento Boleto"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Pagamento Boleto"
              item.tipoLancamento.id == 26
          ).length ? (
            <TableTransfers
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Pagamento Boleto"
                    item.tipoLancamento.id == 26
                )
              }
              title={"BOLEPIX"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Pagamento Boleto"
              item.tipoLancamento.id == 19
          ).length ? (
            <TableTransfersWithStatus
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Pagamento Boleto"
                    item.tipoLancamento.id == 19
                )
              }
              title={"Cancelamento/Falha de Remessa Boleto"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
              item.tipoLancamento.id == 1
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                    item.tipoLancamento.id == 1
                )
              }
              title={"Vendas no cartão de Crédito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
              item.tipoLancamento.id == 2
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                    item.tipoLancamento.id == 2
                )
              }
              title={"Cancelamentos de Vendas no Cartão"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Cartão Débito"
              item.tipoLancamento.id == 18
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Cartão Débito"
                    item.tipoLancamento.id == 18
                )
              }
              title={"Vendas no cartão de Débito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda PIX"
              item.tipoLancamento.id == 10
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda PIX"
                    item.tipoLancamento.id == 10
                )
              }
              title={"Vendas no PIX"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Boleto"
              item.tipoLancamento.id == 9
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Boleto"
                    item.tipoLancamento.id == 9
                )
              }
              title={"Vendas no Boleto"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Disputa"
              item.tipoLancamento.id == 3
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Disputa"
                    item.tipoLancamento.id == 3
                )
              }
              title={"Vendas Disputa"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Chargeback"
              item.tipoLancamento.id == 5
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Chargeback"
                    item.tipoLancamento.id == 5
                )
              }
              title={"Chargeback"}
            />
          ) : (
            <></>
          )}
          <TableSplitExtract data={splitList} />
          <Flex
            w={"97%"}
            minH={"120px"}
            py={4}
            px={10}
            marginX={"auto"}
            mb={4}
            alignItems={"center"}
          ></Flex>
        </Flex>
      ) : (
        <Flex
          w={"100%"}
          h={"60vh"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Spinner color={VARIANT} size="lg" />
        </Flex>
      )}
    </Flex>
  );
}
